// src/OneSignalInit.jsx
import { useEffect } from "react";
import OneSignal from "react-onesignal";

const ONESIGNAL_APP_ID = "1c3be758-190a-477b-bc38-9aee8c91d12b";

export default function OneSignalInit() {
    useEffect(() => {
        // make sure this only runs on the client
        if (typeof window === "undefined") return;

        OneSignal.init({
            appId: ONESIGNAL_APP_ID,
            safari_web_id: "web.onesignal.auto.2fc72fe0-a0df-475b-ad9a-b2dac840a493",
            // any other options you need:
            // safari_web_id: "web.onesignal.auto.xx-xxxx-xxxx",
            // notifyButton: { enable: true },
            allowLocalhostAsSecureOrigin: true, // important for local dev
            autoRegister: true                  // forces permission prompt
        }).then(() => {
            console.log("OneSignal initialized");
            // Example: show native permission prompt
            // OneSignal.Slidedown.promptPush();
        });
    }, []);

    return null; // this component doesn’t render anything
}
